import React, { useEffect, useState } from "react"

import {
  Box,
  Button,
  Typography,
  Stepper,
  Step,
  StepLabel,
} from "@mui/material"
import * as Style from "./style"
import { Link } from "react-router-dom"
import { useAppSelector } from "../../app/hooks"
import paymentFailedImg from "../../images/payment-failed.png"
const steps = ["Booking Summary", "Payment", "Request Sent"]
const PaymentFailed = () => {
  const [activeStep, setActiveStep] = React.useState(2)
  const [skipped, setSkipped] = React.useState(new Set<number>())

  const isStepOptional = (step: number) => {
    return step === 1
  }

  const isStepSkipped = (step: number) => {
    return skipped.has(step)
  }

  const handleReset = () => {
    setActiveStep(1)
  }

  const getStepContent = (step: number) => {
    switch (step) {
      case 2:
        return (
          <Box>
            <Box className="request-sent-wrapper">
              <img src={paymentFailedImg} className="checkedimg" />
              <Typography className="request-sent-heading text-danger fw-bold mt-4">
                Payment Failed
              </Typography>
              <Typography className="text-body">
                Opps! your transaction has failed, please try again later
              </Typography>
              <Link to="/dashboard" className="view-profile w-auto px-4">
                Go back
              </Link>
            </Box>
          </Box>
        )
      default:
        return null
    }
  }

  return (
    <>
      <Box>
        <Style.Overview>
          <Box className="feature-card px-1 py-md-4 px-md-5 position-relative">
            <Stepper activeStep={activeStep} className="stepper-booking pt-3">
              {steps.map((label, index) => (
                <Step key={label} completed={isStepSkipped(index)}>
                  <StepLabel optional={isStepOptional(index) ? "" : null}>
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
            {activeStep === steps.length ? (
              <React.Fragment>
                <Typography sx={{ mt: 2, mb: 1 }}>
                  All steps completed - you&apos;re finished
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button onClick={handleReset}>Reset</Button>
                </Box>
              </React.Fragment>
            ) : (
              <React.Fragment>
                {getStepContent(activeStep)}
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Box sx={{ flex: "1 1 auto" }} />
                </Box>
              </React.Fragment>
            )}
          </Box>
        </Style.Overview>
      </Box>
    </>
  )
}

export default PaymentFailed
